export const COMMENT_ROOT = 'comment'

export const getCommentKey = id => `comment_${id}`

export const isCommentKey = key => typeof key === 'string' && key.startsWith('comment_')

export const getThreadIdFromKey = key => (isCommentKey(key) ? key.slice('comment_'.length) : null)
